import { h } from 'preact';

import formatPercent from '../utils/format-percent';
import numberWithCommas from '../utils/number-with-commas';

const Candidate = ({ candidate, raceCalled, raceUncontested, totalVotes }) => {
  const pill = `pill-circle pill--${candidate.party.slice(0, 3)}`;
  const rowClass = `candidate race__candidate-row${(raceCalled && candidate.winner) ? ' race__candidate-row--winner' : ''}`;

  return (<tr className={rowClass}>
            <td className="candidate__cell candidate__party">
              <span className={pill}>{candidate.party.slice(0, 1).toUpperCase()}</span>
            </td>
            <td className="candidate__cell candidate__name">
              {(raceCalled && candidate.winner) && '\u2713 '}{candidate.ballot_name} {candidate.incumbent && <span class="pill pill--basic">Incumbent</span>}
            </td>
            <td className="candidate__cell candidate__votes">
              {(raceUncontested) ? '-' : numberWithCommas(candidate.votes)}
            </td>
            <td className="candidate__cell candidate__pct">
              {(raceUncontested) ? '-' : formatPercent(candidate.votes, totalVotes)}<span className="candidate__pct-symbol">%</span>
            </td>
          </tr>);
};

export default Candidate;



// WEBPACK FOOTER //
// ./components/candidate.js